<template>
  <div id="app">
    <router-view />
    <div v-show="showTips" class="rotate-tips">
      <svg t="1658387318811" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2359" width="50" height="50">
        <path
          d="M864 960h-256a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96h256a96 96 0 0 1 96 96v704a96 96 0 0 1-96 96z m32-800a32 32 0 0 0-32-32h-256a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V160zM64 864v-256a96 96 0 0 1 96-96h288v64H160a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h288v64H160a96 96 0 0 1-96-96z m256-640H224a32 32 0 0 0-32 32v192H128V256a96 96 0 0 1 96-96h96V64l128 128-128 128V224z"
          p-id="2360"
        ></path>
      </svg>
      请将屏幕竖过来
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTips: false
    }
  },
  created() {
    let that = this
    that.watchOrientationchange()
    window.addEventListener('orientationchange', that.watchOrientationchange2, false)
  },
  mounted() {
    const client_width = document.body.clientWidth
    if (client_width > 750) {
      const ratio = 750 / client_width
      const $app = document.getElementById('app')
      const app_height = $app.clientHeight
      console.log(app_height)
      $app.style.height = app_height / ratio + 'px'
      $app.style.transform = 'scale(' + ratio + ')'
      $app.style.transformOrigin = 'top'
    }
  },
  methods: {
    watchOrientationchange() {
      let that = this
      if (window.orientation == 90 || window.orientation == -90) {
        // console.log('横屏了')
        that.showTips = true
      } else {
        that.showTips = false
      }
    },
    watchOrientationchange2() {
      let that = this
      if (window.orientation == 90 || window.orientation == -90) {
        // console.log('横屏了')
        that.showTips = true
      } else {
        that.showTips = false
        location.reload()
      }
    }
  }
}
</script>
<style lang="stylus">
.loading-box {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  width: 70px;
  height: 70px;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  z-index: 9000;

  .loading {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}

.loading-box2 {
  width: 150px;
  height: 120px;

  span {
    color: #fff;
    margin-top: 8px;
  }
}

.rotate-tips {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}
</style>
<style>
#app {
  scroll-behavior: smooth;
}
* {
  -webkit-appearance: none !important;
}
*::placeholder {
  color: #acacac;
  font-size: 15px;
}

.radio-item:not(:last-child) {
  margin-bottom: 8px;
}
.check-item:not(:last-child) {
  margin-bottom: 8px;
}
</style>
